import axios from 'axios';
import urlJoin from 'url-join';

import { getSource } from 'helpers/Ga';
import { addTokenToHeaders } from 'helpers/Estima';

/* eslint-disable no-param-reassign */

/**
 * Compute energy consumption to return a string value
 * @param {Object} values Current form
 */
function passwordComputation(values) {
    if (values.action === 'signup') {
        values.password2 = values.password;
    }
}

/**
 * Remove field related to user action (signin/signup).
 * @param {Object} values Current form
 */
function actionComputation(values) {
    if (values.action === 'signup') {
        delete values.username;
        delete values.remember_me;
    } else if (values.action === 'signin') {
        delete values.firstname;
        delete values.lastname;
        delete values.email;
        delete values.cell_phone;
        delete values.optin_partners;
        delete values.is_pro;
    }
}

/**
 * Remove field related to user profile (pro or not).
 * @param {Object} values Current form
 */
function profileComputation(values) {
    if (values.action === 'signup') {
        if (!values.is_pro) {
            values.profile = 'USER_PROFILE.REALTOR';
            values.profile_realtor_position = '__None';
        } else {
            values.is_pro = 'true';
        }
    }
}

/**
 * Compute information about CTA on signup.
 * @param  {Object} values Current form
 */
function ctaComputation(values) {
    values.cta_id = getSource();
}

/* eslint-enable no-param-reassign */

/**
 * Transform form data to the API scheme.
 * @param  {Object} values Form data
 * @returns Values in the API scheme
 */
export function prepareValuesToPost(values) {
    const submittedValues = { ...values };

    passwordComputation(submittedValues);
    actionComputation(submittedValues);
    profileComputation(submittedValues);
    ctaComputation(submittedValues);

    return submittedValues;
}

/**
 * Auth API Service.
 */
export default class AuthService {
    /**
     * Auth checker.
     * @return {Promise} Request
     */
    static check() {
        return axios.get(urlJoin(MA.Config.WWW_URL, 'account', 'context'), {
            headers: addTokenToHeaders({ Accept: 'application/json' }),
        });
    }

    /**
     * Update contact
     * @param {Object} values Contact values
     * @param {string} values.cell_phone Contact cellphone
     * @param {string} values.firstname Contact firstname
     * @param {string} values.lastname Contact lastname
     */
    static updateContact({ cell_phone, firstname, lastname } = {}) {
        return axios.put(urlJoin(MA.Config.API_URL, 'contact_information'), {
            cell_phone,
            firstname,
            lastname,
        });
    }
}
